import * as noUiSlider from 'nouislider/distribute/nouislider.js';

var html5Slider = document.getElementById('shop-slider');

if(html5Slider){
    initNoUiSlider();
}

function initNoUiSlider(){
    noUiSlider.create(html5Slider, {
        start: [100, 2000],
        connect: true,
        range: {
            'min': 100,
            'max': 6000
        }
    });
    
    var nodes = [
        document.getElementById('lower-value'), // 0
        document.getElementById('upper-value')  // 1
    ];
    
    // Display the slider value and how far the handle moved
    // from the left edge of the slider.
    html5Slider.noUiSlider.on('update', function (values, handle, unencoded, isTap, positions) {
        nodes[handle].innerHTML = values[handle];
    });
}
